import { CardDash } from '../CardDash';
import { OptiTable } from '@componentsNew/OptiTable';
import ItemTable from '@componentsNew/Table/ItemTable';
import { MdEdit } from 'react-icons/md';
import { useActionParam } from '@api/actions/action';
import { useEffect } from '@wordpress/element';
import Pagination from '@componentsNew/Pagination';

export function ArtigosRascunhoIA() {
  const colunas = [
    { id: 'titulo', header: 'TÍTULO DO ARTIGO', width: 2 },
    { id: 'palavrasChave', header: 'PALAVRAS-CHAVE', width: 2 },
    { id: 'acoes', header: 'AÇÕES', width: 2 },
  ];

  const { data: artigosRascunhoIa, mutateAsync } = useActionParam();

  useEffect(() => {
    mutateAsync({ action: 'obter_rascunhos_ia', param: { current_page: 1, items_per_page: 5 } });
    localStorage.removeItem('artigo_em_edicao');
    localStorage.removeItem('id_artigo_ia');
  }, []);

  const renderizarLinha = item => (
    <tr key={parseInt(item.id)} className="flex justify-between w-full px-6 py-[0.625rem]">
      <ItemTable tamanho="2/12">{item.titulo}</ItemTable>
      <ItemTable tamanho="2/12">
        {item?.palavras_chave === '' ? '-' : item.palavras_chave}
      </ItemTable>
      <ItemTable tamanho="2/12">
        <MdEdit
          className="w-6 h-6 relative cursor-pointer"
          color="#a3a9b0"
          onClick={() => encaminharParaEditor(parseInt(item.id))}
        />
      </ItemTable>
    </tr>
  );

  const encaminharParaEditor = idArtigo => {
    const rascunho = artigosRascunhoIa?.data?.data?.filter(r => parseInt(r.id) == idArtigo)[0];

    if (rascunho) {
      localStorage.setItem('artigo_em_edicao', JSON.stringify(rascunho));
      const domain = window.location.origin;
      let link = `${domain}/wp-admin/admin.php`;
      window.location.href = link + '?page=optimarketing&editar-artigo=' + idArtigo;
    }
  };

  return (
    <CardDash className=" mt-6" titulo="Artigos IA em Rascunho">
      {artigosRascunhoIa?.data && (
        <OptiTable
          colunas={colunas}
          dados={artigosRascunhoIa?.data?.data}
          renderizarLinha={renderizarLinha}
          mensagemSemDados="Sem rascunhos salvos"
        />
      )}
      <Pagination
        totalPaginas={artigosRascunhoIa?.data?.pagination?.total_pages || 0}
        paginaAtual={artigosRascunhoIa?.data?.pagination?.current_page || 0}
        onPageChange={page =>
          mutateAsync({
            action: 'obter_rascunhos_ia',
            param: { current_page: page, items_per_page: 5 },
          })
        }
      />
    </CardDash>
  );
}
